import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormControl, MenuItem, Select, type SelectChangeEvent } from '@mui/material';

import { UserGroupRole } from '@/shared/constants/userGroupRole';
import { useTheme } from '@/theme';

interface RoleSelectProps {
  value: string;
  onChange: (newRole: string) => void;
  disabled?: boolean;
  testId?: string;
}

function RoleSelect({ value, onChange, disabled = false, testId }: RoleSelectProps) {
  const theme = useTheme();

  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth size='small'>
      <Select
        value={value || UserGroupRole.Member}
        onChange={handleChange}
        disabled={disabled}
        MenuProps={{ disableScrollLock: true }}
        data-testid={testId}
        sx={{
          fontSize: theme.hhglobal.typography.body.base.fontSize,
          '& .MuiSelect-icon': {
            color: theme.hhglobal.neutral.superblack,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.hhglobal.neutral.gray500,
            borderWidth: '1px',
          },
        }}
        IconComponent={ExpandMoreIcon}
      >
        <MenuItem value={UserGroupRole.AuthorizedDelegate}>{UserGroupRole.AuthorizedDelegate}</MenuItem>
        <MenuItem value={UserGroupRole.Distributor}>{UserGroupRole.Distributor}</MenuItem>
      </Select>
    </FormControl>
  );
}

export default RoleSelect;
